import {decryptData} from './decryptUserDataUtils'

export default {
  install(app) {
    // Interceptar la función localStorage.getItem
    const originalGetItem = localStorage.getItem;
    localStorage.getItem = function(key) {
      if (key === 'userData') {
        const encryptedData = originalGetItem.call(localStorage, key);
        if (encryptedData) {
          try {
            // Desencriptar la data cuando se obtiene del localStorage
            return decryptData(encryptedData); // Desencriptamos antes de devolverla
          } catch (error) {
            console.error("Error al desencriptar los datos de usuario", error);
            return null;
          }
        }
      }
      // En caso de que no sea 'userData', devuelve el valor normal
      return originalGetItem.call(localStorage, key);
    };

    // Interceptar la función localStorage.setItem
    // const originalSetItem = localStorage.setItem;
    // localStorage.setItem = function(key, value) {
    //   if (key === 'userData') {
    //     try {
    //       // Encriptar la data antes de guardarla en localStorage
    //       const encryptedData = encrypt(JSON.stringify(value));
    //       return originalSetItem.call(localStorage, key, encryptedData); // Guardamos la data encriptada
    //     } catch (error) {
    //       console.error("Error al encriptar los datos de usuario", error);
    //     }
    //   }
    //   // En caso de que no sea 'userData', usa la función setItem original
    //   return originalSetItem.call(localStorage, key, value);
    // };
  }
};
